import { SnackbarService } from '../../_common/client/snackbar-service';
import { CustomerReviewBackendRequester } from './service/customer-review-backend-requester';
import { CustomerReviewItemComponent } from './customer-review-item.component';
import { HelpfulReviewService } from './service/helpful-review-service';
import { LocalStorageService } from './service/local-storage-service';
import { ReportReviewService } from './service/report-review-service';
import { ReportReviewSheetService } from './service/report-review-sheet-service';
import { ClientComponentLogger } from '../../client-component-logger';
import { TextExpanderService } from '../../_common/client/text-expander-service';
import { CustomerReviewTextExpander } from './service/customer-review-text-expander';

export const CustomerReviewItemFactory = () => {
    const customerReviewBackendRequester = new CustomerReviewBackendRequester(new ClientComponentLogger(CustomerReviewItemComponent.name));
    const localStorageService = new LocalStorageService();
    const snackbarService = new SnackbarService();
    const helpfulReviewService = new HelpfulReviewService(customerReviewBackendRequester, localStorageService, snackbarService);

    const reportReviewSheetService = new ReportReviewSheetService(customerReviewBackendRequester, snackbarService);
    const reportReviewService = new ReportReviewService(reportReviewSheetService);

    const textExpanderService = new TextExpanderService();

    return new CustomerReviewItemComponent(helpfulReviewService, reportReviewService, new CustomerReviewTextExpander(textExpanderService));
};
